import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedClient: null, 
  selectedCompanyId: null,
  selectedCompany: null,
  selectedCompanyInfo: {},
  selectedAddress: {},
  selectedContactInfo: {},
  selectedBusinessInfo: {},
  selectedTaxInfo: {},
  selectedComplianceInfo: {},
  selectedBankingInfo: [],
  kycData: [], 
};

export const kycSlice = createSlice({
  name: 'kyc',
  initialState,
  reducers: {
    setSelectedCompanyId: (state, action) => {
      state.selectedCompanyId = action.payload;
    },
    setSelectedCompany: (state, action) => {
      state.selectedCompany = action.payload;
    },
    setSelectedCompanyDetails: (state, action) => {
      const {
        companyInfo,
        address,
        contactInfo,
        businessInfo,
        taxInfo,
        complianceInfo,
        bankingInfo,
      } = action.payload;

      state.selectedCompanyInfo = companyInfo;
      state.selectedAddress = address;
      state.selectedContactInfo = contactInfo;
      state.selectedBusinessInfo = businessInfo;
      state.selectedTaxInfo = taxInfo;
      state.selectedComplianceInfo = complianceInfo;
      state.selectedBankingInfo = bankingInfo;
    },
    setKycData: (state, action) => {
      state.kycData = action.payload; 
    },
    clearSelectedCompany: (state) => {
      state.selectedCompanyId = null;
      state.selectedCompany = null;
      state.selectedCompanyInfo = {};
      state.selectedAddress = {};
      state.selectedContactInfo = {};
      state.selectedBusinessInfo = {};
      state.selectedTaxInfo = {};
      state.selectedComplianceInfo = {};
      state.selectedBankingInfo = [];
      state.kycData = [];
    },
  },
});

export const { setSelectedCompanyId, setSelectedCompany, setSelectedCompanyDetails, setKycData, clearSelectedCompany } = kycSlice.actions;

export default kycSlice.reducer;
